module.exports = __webpack_public_path__ + "static/media/Sec-4_Banner_CN.152468cc.png";